// extracted by mini-css-extract-plugin
module.exports = {"section":"Push_section__1emSK","container":"Push_container__3IA-J","body":"Push_body__5d1Ly","title":"Push_title__3JdYn"};